export function parseParamWithQuery(params, propertyName, searchParams = "") {
  if (!params || !params[propertyName]) return params;

  const value = params[propertyName];
  let [id, queryString] = value.split("?"); // split only if ? exists
  const query = {};

  // fallback: use location.search if no query string in subjectId
  if (!queryString && searchParams) {
    queryString = searchParams.startsWith("?")
      ? searchParams.slice(1)
      : searchParams;
  }

  if (queryString) {
    queryString.split("&").forEach(pair => {
      const [key, val] = pair.split("=");
      query[key] = decodeURIComponent(val || "");
    });
  }

  console.log({
    ...params,
    [propertyName]: id,
    query:Object.keys(query).length ? query : {}
  })

  return {
    ...params,
    [propertyName]: id,
    query:Object.keys(query).length ? query : {}
  };
}

export const getImageURL = (url) => {
  return url
    ? url
    : process.env.PUBLIC_URL + '/backgrounds/modules/pdfImage.png';
};
